import { DispatchOnly } from "../../../../telemetry/DispatchOnly";
import { Measures } from "../../../../telemetry/Measures";
import { dashboard } from "../../../../telemetry/TraceLogging";
import { TelemetryData } from "../../../../telemetry/TelemetryData";
export function logPageEvent(page) {
    Measures.logEvent(dashboard, "WebAppLandingPage", 16777216 /* productAndServicePerformance */, {
        Page: page,
    });
}
export function logPageShown(page, aepPayloadContentType, lastShowReason, additionalData) {
    let partCPayload = Object.assign({ Page: page, aepPayloadContentType: aepPayloadContentType, lastShowReason: lastShowReason }, additionalData);
    TelemetryData.isWindowVisible = true;
    Measures.logEvent(dashboard, "WebAppLandingPageShown", 16777216 /* productAndServicePerformance */, partCPayload);
    DispatchOnly.logEvent(dashboard, "WebAppLandingPageShown", 1 /* diagnosticData */, 16777216 /* productAndServicePerformance */, partCPayload);
}
export function logPageHidden(page, additionalData) {
    let partCPayload = Object.assign({ Page: page }, additionalData);
    TelemetryData.isWindowVisible = false;
    Measures.logEvent(dashboard, "WebAppLandingPageHidden", 16777216 /* productAndServicePerformance */, partCPayload);
    DispatchOnly.logEvent(dashboard, "WebAppLandingPageHidden", 1 /* diagnosticData */, 16777216 /* productAndServicePerformance */, partCPayload);
}
